import {
    GET_WASH_CHANGE_REQUEST,
    GET_WASH_CHANGE_SUCCESS,
    GET_WASH_CHANGE_ERROR
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_WASH_CHANGE_REQUEST:
            return {
                loading: true,
            };
        case GET_WASH_CHANGE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_WASH_CHANGE_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}